import { Base } from '../../components/base-component';
import { AnalyticsService } from "../../services/analytics.service";

import './form-item-hs-vas-statistics.component.scss';

export class FormItemHsVasStatistics extends Base {

	form: HTMLFormElement;
	successMessage: HTMLFormElement;
	errorMessage: HTMLFormElement;

	submitButton: Element[];

	movingDate: HTMLFormElement[];
	preferedMovingDate: HTMLFormElement;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.successMessage = this.form.querySelector(".form__success--container");
		this.errorMessage = this.form.querySelector(".form__serror--container");
		this.submitButton = Array.from(this.element.querySelectorAll('.js-hs-vas-statistics__button'));
	}

	bindEvents() {
		this.submitButton.map((item) => item.addEventListener('click', (event) => {
			const _button = event.target as HTMLFormElement;
			const _form = _button.closest('form') as HTMLFormElement;
			const formFields: any = _form.querySelectorAll('input, select');
			this.validationService.validate(formFields);
			const valid = Array.from(_form.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.submitForm(_form);
			}
		}));

		// Reset the form
		this.form.addEventListener('custom_form_reset_event', (e) => {
			if (this.errorMessage) {
				this.errorMessage.classList.remove('active');
			}
			if (this.successMessage) {
				this.successMessage.classList.remove('active');
			}
		}, false);
	}

	submitForm(form: HTMLFormElement) {
		// success screens
		const loader = form.querySelector('.form__loader--container');
		const thankYou = form.querySelector('.form__thankyou--container');
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		let success = form.querySelector('.form__success--container');
		let error = form.querySelector('.form__error--container');

		// fields
		const requiredProfession: any = form.querySelector('input[name=profession]');
		const suburb: any = form.querySelector('input[name=suburb]');

		// loader + hide form
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		const fields: any = 'vicinitiesparams=' + ((requiredProfession) ? requiredProfession.value : '') + ',' + ((suburb) ? suburb.value : '');

		let analyticsService = new AnalyticsService();
		let url = "/homeservices/sbhsvicinities";

		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, fields, config).then((response: any) => {
			// service ok
			analyticsService.dtmFormComplete('complete', 'true');
			loader.classList.remove('active');
			analyticsService.dtmFormComplete('complete', '');
			thankYou.classList.add('active');
			success.classList.add('active');
		}).catch(response => {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			fieldsContainer.classList.remove('active');
			thankYou.classList.remove('active');
			error.classList.add('active');
		});
	}
}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-hs-vas-statistics/form-item-hs-vas-statistics.component.ts